<style>
.spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}


</style>


<template>
  <div class="home mt-3">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">Productos</h2>
        <div class="input-group my-1" style="max-width: 340px;">
          <input
            type="text"
            v-model="busqueda_global"
            class="form-control form-control-sm"
            @keyup.enter="onBuscar"
            placeholder="Buscar en todos los campos..."
          />
          <div class="input-group-append">
            <button @click="onBuscar" class="btn btn-sm btn-info">
              <i class="bi-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button class="btn btn-sm btn-principal mr-2" @click="getProductosExcel">
          <i class="bi-download"></i> Descargar listado completo
        </button>
        <button
          v-if="!isApruebaProducto()"
          class="btn btn-sm btn-principal"
          data-toggle="tooltip"
          data-placement="top"
          title="Nuevo Producto"
          @click="showEdit({}, 'add')"
        >
          <i class="bi-plus"></i> Nuevo Producto
        </button>
      </div>
    </div>

    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>
    <empty-state
      :show="Boolean(post && productosBusqueda && productosBusqueda.data && !productosBusqueda.data.length)"
      message="No se encontraron productos que coincidan con la búsqueda."
    />
    <table
      class="table xtable-responsive table-striped xtable-fixed table-sm"
      v-if="productosBusqueda && productosBusqueda.data && productosBusqueda.data.length"
    >
      <thead>
        <tr>
          <th
            @click="orderByfield('id_producto')"
            class="tablesorter-header"
            :class="orderClass('id_producto')"
            scope="col"
            width="80"
          >
            Id
          </th>
          <th
            @click="orderByfield('producto')"
            class="tablesorter-header"
            :class="orderClass('producto')"
            scope="col"
          >
            Producto
          </th>
          <th
            @click="orderByfield('alias')"
            class="tablesorter-header"
            :class="orderClass('alias')"
            scope="col"
          >
            Alias
          </th>

          <th
            @click="orderByfield('activo')"
            class="tablesorter-header"
            :class="orderClass('activo')"
            scope="col"
          >
            Estado
          </th>
          <th
            @click="orderByfield('aprobacion')"
            class="tablesorter-header"
            :class="orderClass('aprobacion')"
            scope="col"
          >
            Aprobación
          </th>
          <th scope="col" width="110"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="productoItem of productosBusqueda.data"
          v-bind:key="productoItem.id_producto"
        >
          <th scope="row">{{ productoItem.id_producto }}</th>
          <td>{{ productoItem.producto }}</td>
          <td>{{ productoItem.alias }}</td>

          <td>
            <status-badge :value="productoItem.activo" />
          </td>
          <td :class="aprobacionClass(productoItem.aprobacion)">
            {{ productoItem.aprobacion }}
          </td>
          <td>
            <nobr>
              <button
                v-if="!isApruebaProducto()"
                type="button"
                class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Atributos del producto"
                @click="openAtributosModal(productoItem)"
              >
                <small class="bi-bar-chart-steps"></small>
              </button>

              <button
                v-if="isApruebaProducto()"
                class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Ver Producto"
                @click="showEdit(productoItem, 'ver')"
              >
                  <small class="bi-eye"></small>
              </button>
               <button
                v-if="productoItem.aprobacion=='PENDIENTE' && isApruebaProducto()"
                class='btn btn-success btn-sm pt-0 pb-1'
                data-toggle="tooltip"
                data-placement="top"
                title='Aprobar Producto'
                @click="showEdit(productoItem, 'aprueba')"
              >
                <small class="bi-check-lg"></small>
              </button>
              <button
                v-if="productoItem.aprobacion=='PENDIENTE' && isApruebaProducto() "
                class='btn btn-danger btn-sm pt-0 pb-1'
                data-toggle="tooltip"
                data-placement="top"
                title='Rechazar Producto'
                @click="showEdit(productoItem, 'rechaza')"
              >
                <small class="bi-x-lg"></small>
              </button>

              <button
                v-if="!isApruebaProducto()"
                class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="Editar Producto"
                @click="showEdit(productoItem, 'edit')"
              >
                <small class="bi-pencil-fill"></small>
              </button>
              <button
                              v-if="!isApruebaProducto()"

                :class="
                  productoItem.activo == '1'
                    ? 'btn btn-warning btn-sm pt-0 pb-1'
                    : 'btn btn-success btn-sm pt-0 pb-1'
                "
                data-toggle="tooltip"
                data-placement="top"
                :title="
                  productoItem.activo == '1'
                    ? 'Suspender producto'
                    : 'Reactivar producto'
                "
                @click="showEdit(productoItem, 'toggle')"
              >
                <small
                  :class="productoItem.activo == '1' ? 'bi-pause' : 'bi-play'"
                ></small>
              </button>


            </nobr>
          </td>
        </tr>
      </tbody>
    </table>
    <Paginador
      v-if="productosBusqueda && productosBusqueda.pages"
      :pages="productosBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <div
      v-if="
        !(
          productosBusqueda &&
          productosBusqueda.data &&
          productosBusqueda.data.length
        ) && post
      "
    >
      <div class="alert alert-info">
        No se obtubieron atributos con el criterio seleccionado.
      </div>
    </div>
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal Flotante de Atributos -->
    <div v-if="showAtributosModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
              <div class="modal-content shadow-lg border-0">
                <div class="modal-header bg-dark text-white">
                  <h5 class="modal-title">
                    <i class="bi bi-bar-chart-steps mr-2"></i>Atributos del Producto: <b>{{ selectedProductoAtributos ? (selectedProductoAtributos.producto || selectedProductoAtributos.nombre || selectedProductoAtributos.descripcion || ('ID: ' + selectedProductoAtributos.id_producto)) : '' }}</b>
                  </h5>
                  <button type="button" class="close text-white" aria-label="Cerrar" @click="closeAtributosModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body p-3">
                  <Atributos
                    v-if="selectedProductoAtributos"
                    :propProducto="selectedProductoAtributos.id_producto"
                    :isModal="true"
                  />
                </div>
                <div class="modal-footer py-2">
                  <button type="button" class="btn btn-secondary btn-sm" @click="closeAtributosModal">
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal" >
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-dialog-scrollable modal-lg"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Producto</span>
                    <span v-if="editData.activo == 0"> Reactivar Producto</span>
                  </h5>
                    <h5 v-if="operation == 'aprueba'" class="modal-title">
                    Aprobar Producto {{ editData.id_producto }}
                  </h5>
                                      <h5 v-if="operation == 'rechaza'" class="modal-title">
                    Rechazar Producto {{ editData.id_producto }}
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar Producto {{ editData.id_producto }}
                  </h5>
                  <h5 v-if="operation == 'add'" class="modal-title">
                    Nuevo Producto
                  </h5>
                  <h5 v-if="operation == 'ver'" class="modal-title">
                    Producto {{ editData.id_producto }} <span class="alert-danger" v-if="editData.aprobacion=='APROBADO'">{{editData.tipificacion}}</span>
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <ul
                    v-if="
                      operation == 'delete' ||
                      operation == 'edit' ||
                      operation == 'ver' ||
                      operation == 'add'
                    "
                    class="nav nav-tabs"
                    id="modal_title_tabs_users"
                    role="tablist"
                  >
                    <li 
  v-if="
                      operation == 'delete' ||
                      operation == 'edit' ||
                      operation == 'add'
                    "

                    class="nav-item">
                      <a
                        class="nav-link active"
                        id="info_basic-tab"
                        data-toggle="tab"
                        href="#info_basic"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Información básica</a
                      >
                    </li>
 <li class="nav-item" v-if="operation == 'ver'">
                      <a
                        class="nav-link"
                        id="info_basic1-tab"
                        data-toggle="tab"
                        href="#info_basic1"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="true"
                        >Información básica</a
                      >
                    </li>
                      <li class="nav-item" v-if="operation == 'ver'">
                      <a
                        class="nav-link"
                        id="info_cobros2-tab"
                        data-toggle="tab"
                        href="#info_cobros2"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                        >Reglas de cobro</a
                      >
                    </li>

                      <li class="nav-item" v-if="operation == 'ver'">
                      <a
                        class="nav-link"
                        id="info_atributos2-tab"
                        data-toggle="tab"
                        href="#info_atributos2"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                        >Atributos asociados</a
                      >
                    </li>
                  </ul>


                  <div v-if="operation== 'ver'"  class="tab-content" id="myTabContent">
                       <div
                        class="tab-pane fade show active"
                        id="info_basic1"
                        role="tabpanel"
                        aria-labelledby="info_basic1"
                      >
                        <br />

                        <div class="row">
                          <div class="col-md-6">
                              <ul>
                                  <li>Producto: <b>{{editData.producto}}</b></li>
                                  <li>Alias: <b>{{editData.alias}}</b></li>
                                  <li v-if="editData.categorias.length>0">
                                    Categoria/s:
                                    <b v-for="catego in editData.categorias" v-bind:key="catego">
                                      <span v-if="categorias.data[catego-1]" >
                                        {{categorias.data[catego-1].categoria}}  
                                      </span>
                                    </b>
                                  </li>
                              </ul>
                          </div>
                          <div class="col-md-6">


<h5 v-if="atributos.restriction_send || atributos.restriction_days">Envio de contenidos:</h5>
<ul>
    <li v-if="atributos.restriction_send">Contenidos a enviar: {{atributos.restriction_send.split(':')[0]}} cada {{atributos.restriction_send.split(':')[1]}} días </li>
    <li v-if="atributos.restriction_days">Días de envio: <b v-for="diadata in atributos.restriction_days.split(',')" v-bind:key="diadata"

      >{{dias[diadata]}} </b></li>
    </ul>
                          </div>



                        </div>

                  </div>



                       <div
                        class="tab-pane fade"
                        id="info_cobros2"
                        role="tabpanel"
                        aria-labelledby="info_cobros2"
                      >
                        <br />

                        <div class="row">
                          <div class="col-md-12">
<div class="container">

  <label> Secuencia de Cobro:</label>
                  
                                  <b   v-for="billing in billingsequences"
                                  v-bind:key="billing.id_billing_sequence"
                                  v-bind:value="billing.id_billing_sequence"

                                  >
                                  <span v-if="billing.id_billing_sequence == billing_sequence_select">
                                    {{ billing.descripcion }}
                                  </span>

                                  </b>
                            </div>
                            
                          <div v-if="cuadro.precioFinal" class="container">
                            <fieldset style="width: 100%; margin: 5px auto">
                              <div
                                class="infoGral"
                                style="margin-bottom: 4px; overflow: auto"
                              >
                                <div class="fl-left al-left" style="width: 50%">
                                  <strong>Precio final: </strong
                                  ><span id="full_price">{{
                                    cuadro.precioFinal
                                  }}</span>
                                </div>
                                <div class="fl-left al-left" style="width: 50%">
                                  <strong>Cobros:</strong
                                  ><span id="cobros">{{ cuadro.cobros }}</span>
                                </div>
                                <div
                                  class="fl-left al-left"
                                  style="width: 100%"
                                >
                                  <strong>id Secuencia: </strong
                                  ><span id="id_secuence">{{
                                    cuadro.id_billing_sequence
                                  }}</span>
                                </div>
                              </div>
                              <h4 style="font-size: 12px">
                                Payments utilizados
                              </h4>
                              <div
                                class="dataTables_wrapper"
                                id="fullPriceSequenceDetailsTable_wrapper"
                              >
                                <div
                                  class="
                                    fg-toolbar
                                    ui-toolbar
                                    ui-widget-header
                                    ui-corner-tl
                                    ui-corner-tr
                                    ui-helper-clearfix
                                  "
                                ></div>
                                <table
                                  class="
                                    table
                                    xtable-responsive
                                    table-striped
                                    xtable-fixed
                                    table-sm
                                  "
                                  style="width: 100%"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        class="ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          #<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-triangle-1-n
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Código TAS<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="al-right ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Precio s/imp.<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="al-right ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Precio c/imp.<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      class="odd tpar"
                                      v-for="payment in cuadro.payments"
                                      v-bind:key="payment.id_billing_code || payment.id"
                                    >
                                      <td class="sorting_1">
                                        {{ payment.id_billing_code || payment.id }}
                                      </td>
                                      <td>{{ payment.cod_tas || '-' }}</td>
                                      <td class="al-right">
                                        ${{ payment.precio_sin_imp || payment.precioSinImp }}
                                      </td>
                                      <td class="al-right">
                                        ${{ payment.precio_con_imp || payment.precioConImp }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="
                                    fg-toolbar
                                    ui-toolbar
                                    ui-widget-header
                                    ui-corner-bl
                                    ui-corner-br
                                    ui-helper-clearfix
                                  "
                                ></div>
                              </div>
                            </fieldset>
                          </div>


















                          </div>
                        </div>
                    </div>

                       <div
                        class="tab-pane fade"
                        id="info_atributos2"
                        role="tabpanel"
                        aria-labelledby="info_atributos2"
                      >
                        <br />

                        <div class="row">
                          <div class="col-md-12">



<ul>
  

   <li>Mensaje de Opt-in:<br>
    <b v-if="atributos.optin_message">  {{atributos.optin_message}}   </b>
    <b v-else>Sin datos</b>
    <br>
  </li>
   <li>Mensaje de Already Subscribe:<br>
    <b v-if="atributos.already_message">  {{atributos.already_message}}</b>
        <b v-else>Sin datos</b>
    <br>
  </li>
   <li>Keyword Baja Crosselling:<br>
    <b v-if="atributos.crossselling_unsubscribe_service">  {{atributos.crossselling_unsubscribe_service}}</b>
        <b v-else>Sin datos</b>
    <br>
  </li>
   <li>Mensaje Baja Crosselling:<br>
    <b v-if="atributos.crossselling_unsubscribe_message">  {{atributos.crossselling_unsubscribe_message}}</b>
        <b v-else>Sin datos</b>
    <br>
  </li>
   <li>Horas try and buy:<br>
    <b v-if="atributos.try_and_buy">  {{atributos.try_and_buy}}</b>
        <b v-else>Sin datos</b>
    <br>
  </li>
   <li>URL:<br>
    <b v-if="atributos.url_club">  {{atributos.url_club}}</b>
        <b v-else>Sin datos</b>
    <br>
  </li>



</ul>














                          </div>
                        </div>
                      </div>







</div>

                  <form
                    v-if="
                      operation == 'delete' ||
                      operation == 'edit' ||
                      operation == 'add'
                    "
                  >
                    <div class="tab-content" id="myTabContent">
                      <div
                        class="tab-pane fade show active"
                        id="info_basic"
                        role="tabpanel"
                        aria-labelledby="info_basic"
                      >
                        <br />

                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Producto</label>
                              <b
                                class="form-control"
                                v-if="operation == 'delete'"
                              >
                                {{ editData.producto }}
                              </b>
                              <input
                                class="form-control"
                                v-if="operation == 'edit' || operation == 'add'"
                                type="text"
                                placeholder="Ej: Club Juegos"
                                v-model="editData.producto"
                              />
                              <small class="form-text text-muted">Nombre comercial o descripción del producto.</small>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Alias</label>
                              <b
                                class="form-control"
                                v-if="operation == 'delete'"
                              >
                                {{ editData.alias }}
                              </b>
                              <input
                                class="form-control"
                                v-if="operation == 'edit' || operation == 'add'"
                                type="text"
                                placeholder="Ej: clubjuegos"
                                v-model="editData.alias"
                              />
                              <small class="form-text text-muted">Identificador corto sin espacios ni acentos (máx. 50 caracteres).</small>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div
                              v-if="operation == 'edit' || operation == 'add'"
                              class="form-group"
                            >
                              <label>Categoría</label>

                              <select
                               v-if="operation == 'edit' || operation == 'add'"
                                multiple
                                class="form-control"
                                v-model="editData.categorias"
                                aria-label="Categoría"
                              >
                                <option selected="select" value="">
                                  Seleccione una o varias categorías...
                                </option>
                                <template v-if="categorias && categorias.data">
                                  <option
                                    v-for="categoria in categorias.data"
                                    v-bind:key="categoria.id_categoria"
                                    v-bind:value="categoria.id_categoria"
                                  >
                                    {{ categoria.id_categoria }} -
                                    {{ categoria.categoria }}
                                  </option>
                                </template>
                              </select>
                              <small class="form-text text-muted">Mantenga presionado Ctrl (o Cmd) para seleccionar varias categorías.</small>
                            </div>
                          </div>
                          <div class="col-md-6">
                                        <div
                              v-if="operation == 'edit' || operation == 'add'"
                              class="form-group"
                            >
                              <label> Secuencia de Cobro:</label>
                              <select
                                class="form-control"
                                v-model="billing_sc_payments"
                                aria-label="Secuencia de Cobro"
                                @change="
                                  getCuadroBilling(billing_sc_payments)
                                "
                                :disabled="operation == 'edit'"
                              >
                                <option selected="select" value="">
                                  Seleccione un valor...
                                </option>
                                <option
                                  v-for="billing in billingsequences"
                                  v-bind:key="billing.id_billing_sequence"
                                  v-bind:value="billing.id_billing_sequence"
                                >
                                  {{ billing.descripcion }}
                                </option>
                              </select>
                              <small class="form-text text-muted">Secuencia de cobro asignada al producto.</small>
                            </div>
                          <!--   <div
                              v-if="operation == 'edit' || operation == 'add'"
                              class="form-group"
                            >
                              <label>Formato de envio de contenidos</label>

                              <select
                                v-if="operation == 'edit' || operation == 'add'"

                                class="form-control"
                                v-model="editData.tipo"
                                aria-label="Tipo"
                              >
                                <option selected="select" value="">
                                  Seleccione un formato...
                                </option>
                                <template v-if="tipos">
                                  <option
                                    v-for="tipo in tipos"
                                    v-bind:key="tipo"
                                    v-bind:value="tipo"
                                  >
                                    {{ tipo }}
                                  </option>
                                </template>
                              </select>
                              <small class="alert info">
                                <ul>
                                  <li>
                                    *RND: seleccion aleatoria de contenidos
                                  </li>
                                  <li>
                                    *SEC: seleccion secuencial de contenido
                                  </li>
                                </ul>
                              </small>
                            </div> -->
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
      
                          </div>
                          <div class="col-sm-6">
                 
                          </div>
                          <div v-if="cuadro.precioFinal" class="container">
                            <fieldset style="width: 100%; margin: 5px auto">
                              <div
                                class="infoGral"
                                style="margin-bottom: 4px; overflow: auto"
                              >
                                <div class="fl-left al-left" style="width: 50%">
                                  <strong>Precio final: </strong
                                  ><span id="full_price">{{
                                    cuadro.precioFinal
                                  }}</span>
                                </div>
                                <div class="fl-left al-left" style="width: 50%">
                                  <strong>Cobros:</strong
                                  ><span id="cobros">{{ cuadro.cobros }}</span>
                                </div>
                                <div
                                  class="fl-left al-left"
                                  style="width: 100%"
                                >
                                  <strong>id Secuencia: </strong
                                  ><span id="id_secuence">{{
                                    cuadro.id_Secuencia
                                  }}</span>
                                </div>
                              </div>
                              <h4 style="font-size: 12px">
                                Payments utilizados
                              </h4>
                              <div
                                class="dataTables_wrapper"
                                id="fullPriceSequenceDetailsTable_wrapper"
                              >
                                <div
                                  class="
                                    fg-toolbar
                                    ui-toolbar
                                    ui-widget-header
                                    ui-corner-tl
                                    ui-corner-tr
                                    ui-helper-clearfix
                                  "
                                ></div>
                                <table
                                  class="
                                    table
                                    xtable-responsive
                                    table-striped
                                    xtable-fixed
                                    table-sm
                                  "
                                  style="width: 100%"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        class="ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          #<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-triangle-1-n
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Código TAS<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="al-right ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Precio s/imp.<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="al-right ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Precio c/imp.<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      class="odd tpar"
                                      v-for="payment in cuadro.payments"
                                      v-bind:key="payment.id_billing_code || payment.id"
                                    >
                                      <td class="sorting_1">
                                        {{ payment.id_billing_code || payment.id }}
                                      </td>
                                      <td>{{ payment.cod_tas || '-' }}</td>
                                      <td class="al-right">
                                        ${{ payment.precio_sin_imp || payment.precioSinImp }}
                                      </td>
                                      <td class="al-right">
                                        ${{ payment.precio_con_imp || payment.precioConImp }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="
                                    fg-toolbar
                                    ui-toolbar
                                    ui-widget-header
                                    ui-corner-bl
                                    ui-corner-br
                                    ui-helper-clearfix
                                  "
                                ></div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="errors"
                      class="alert alert-danger my-2"
                      role="alert"
                    >
                      <i class="bi bi-exclamation-triangle me-1"></i>
                      {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
                    </div>
                  </form>
                  <p v-if="operation == 'toggle'" >
                    Esta seguro de realizar esta acción?
                  </p>
                  <div v-if="operation == 'rechaza' ">
                    <label for="motivoRechazo">Motivo de Rechazo</label>

                              <textarea
                                type="text"
                                class="form-control"
                                id="motivo_rechazo"
                                v-model="motivoRechazo"
                                aria-label="motivo_rechazo"
                              ></textarea>
                  </div>
                  <div v-if="operation == 'aprueba' ">


<p>A continuación se va a proceder a aprobar el producto seleccionado. por favor confirme dicha acción.</p>           
                </div>
                <div
                  v-if="errors && operation != 'add' && operation != 'edit'"
                  class="alert alert-danger my-2"
                  role="alert"
                >
                  <i class="bi bi-exclamation-triangle me-1"></i>
                  {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
                </div>
              </div>
                <div class="modal-footer">

                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'delete'"
                    @click="deleteProducto"
                    class="btn btn-primary"
                  >
                    Borrar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'aprueba'"
                    @click="aprobarProducto"
                    class="btn btn-primary"
                  >
                    Aprobar
                  </button>
                                    <button
                    type="button"
                    v-if="operation == 'rechaza'"
                    @click="rechazarProducto"
                    class="btn btn-primary"
                  >
                    Rechazar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'"
                    @click="editProducto"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add'"
                    @click="agregarProducto"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import StatusBadge from "./utiles/StatusBadge.vue";
import EmptyState from "./utiles/EmptyState.vue";
import Atributos from "./Atributos.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";
import { fetchCachedCatalog } from "../../utils/filterCache";

export default {
  name: "Productos",
  mixins: [tableSortMixin],
  data() {
    return {
      showAtributosModal: false,
      selectedProductoAtributos: null,
      busqueda_global: '',
      billRestriction:null,
      scPayments:null,
      scFrequency:null,
      scLifetime:null,
      scPrice:null,
      scPriceImp:null,
      activo_sel: null,
      success: null,
      id_producto: null,
      atributos: [],
      atributosDefault:[],
      atributosProd:[],
      atributosFinal:[],
      disabled_pin_message:false,
      disabled_already_message:false,
      billing_sequence_select: "",
      billing_sc_payments: "",
      billingSequence: null,
      error: null,
      tipos: ["SEQ", "RND"],
      billingsequences: null,
      categorias: "",
      alias_sel: null,
      id_categoria_sel: "",
      aprobacion_sel: 'pendiente',
      id_integrador_sel: parseInt(localStorage.getItem("integrador")),
      producto_sel: null,
      productosBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      cuadro: [],
      pages: null,
      motivoRechazo:'',
      dias:['nada','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado','Domingo'],
         attribu:{
      'billing_sequence_id':'',
      'apigw_v2t_service':'',
      'apigw_use_rbt':'',
      'apigw_iscustomer_keyword':'',
      'apigw_invoce_charge_code':'',
      'try_and_buy':'',
      'crossselling_unsubscribe_message':'',
      'url_club':'',
      'pin_message':'',
      'optin_message':'',
      'mail_aprobacion':'',
      'already_message':''},
      counter: 0,
      ocultotabla: Boolean,
    };
  },
  components: {
    Paginador,
    StatusBadge,
    EmptyState,
    Atributos,
  },
  created() {
    this.ocultotabla = false;
    if (this.user && this.user.rol == "apruebaproductos") {
      this.orderByField = "aprobacion";
      this.getProductosBusquedaTodos();
    } else {
      this.getProductosBusqueda();
    }
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  methods: {
    cargarFiltros: function () {
      return Promise.allSettled([
        this.getCategorias(),
        this.getBillinSequences()
      ]);
    },
    productosBuscar: function () {
      this.changePage(1);
    },

    aprobacionClass: function (estado) {
      return estado == "APROBADO"
        ? "text-success"
        : estado == "PENDIENTE"
        ? "text-warning"
        : "text-danger";
    },
    changePage: function (page) {
      this.page = page;
      if (this.user && this.user.rol == "apruebaproductos") {
        this.getProductosBusquedaTodos(false);
      } else {
        this.getProductosBusqueda(false);
      }    
    },

    getBillinSequences: function () {
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "billingsequence/list", {
        id_integrador: this.id_integrador_sel,
      })
        .then((response) => {
          this.billingsequences = (response && response.data && response.data.data) ? response.data.data : (response && response.data ? response.data : []);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getCategorias(id_producto) {
      this.categorias = null;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "categoria/list", {
        id_producto: id_producto,
      })
        .then((response) => {
          this.categorias = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },




    getAtributosDefault: function () {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "atributo/defecto")
        .then((response) => {
          this.atributosDefault = response.data.data;
          this.atributosFinal = response.data.data;
          this.atributosDefault.apigw_use_rbt=0;

          this.disabled_pin_message=this.atributosFinal.pin_message;
          this.disabled_already_message=this.atributosFinal.already_message;

        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    getAtributosProducto(id_producto) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/atributos",{
          id_producto: id_producto,
        })
        .then((response) => {
          this.atributos = response.data;
          this.getCuadroBilling(this.atributos.billing_sequence_id);

          this.atributos.billing_sequence_id = this.billing_sequence_id;
          this.billing_sc_payments = this.atributos.billing_sequence_id;

        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    getBillingSequence: function (id_producto) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/getBillingSequence", {
          id_producto: id_producto,
        })
        .then((response) => {
          if (response.data.billing_sequence_id) {
            this.billing_sequence_select = response.data.billing_sequence_id;
            this.billing_sc_payments = response.data.billing_sequence_id;
            this.getCuadroBilling(this.billing_sequence_select);
          } else {
            this.billing_sc_payments = "";
            this.billing_sequence_select = "";
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },


  onBuscar() {
    this.getProductosBusqueda(true); // Realiza la búsqueda cuando el usuario hace clic
  },

    getCuadroBilling: function (billingCodes) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/getCuadro", {
          billingCodes: billingCodes,
        })
        .then((response) => {
          if (response.data.precioFinal) {
            this.cuadro = response.data;
            //OBTENGO ATRIBUTOS QUE NO VAN A ESTAR MAS
            this.scPayments = response.data.sequence;
            this.scFrequency = response.data.scFrequency;
            this.scLifetime =response.data.scLifetime;
            this.scPrice = response.data.scPrice;
            this.scPriceImp = response.data.scPriceImp;
            this.billRestriction= response.data.billRestriction;
            this.billing_sequence_id = response.data.id_billing_sequence || response.data.id_Secuencia;
            //FIN DE OBTENGO ATRIBUTOS QUE NO VAN A ESTAR MAS

          } else {
            this.cuadro = "";
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    orderByfield: function (field) {
      this.toggleOrder(field);
      if (this.user && this.user.rol == "apruebaproductos") {
        this.getProductosBusquedaTodos(false);
      } else {
        this.getProductosBusqueda(false);
      }
    },
   async getProductosBusqueda(hideResult = true) {
  if (hideResult) this.productosBusqueda = null;

  this.post = false;
  this.$store.commit("setLoading", true);

  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_URL}producto/busqueda`,
      {
        page: this.page,
        busqueda: this.busqueda_global,
        id_integrador: this.id_integrador_sel,
        producto: this.producto_sel,
        alias: this.alias_sel,
        activo: this.activo_sel,
        order_by: {
          field: this.orderByField,
          order: this.orderByDirection,
        },
      }
    );

    this.productosBusqueda = response.data;
  } catch (e) {
    this.errors.push(e);

    const mensaje =
      e.response?.status === 429
        ? "Espere un momento y vuelva a intentarlo."
        : "Ha ocurrido un error al buscar los Productos";

    Swal.fire({
      title: "Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  } finally {
    this.$store.commit("setLoading", false);
    this.post = true;
  }
},


  getProductosBusquedaTodos: function (hideResult = true) {
      if (hideResult) this.productosBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/busqueda", {
          page: this.page,
          aprobacion: this.aprobacion_sel,
          producto: this.producto_sel,
          alias: this.alias_sel,
          activo: this.activo_sel,
          order_by: { field: 'aprobacion, id_producto', order: this.orderByDirection },
        })
        .then((response) => {
          this.productosBusqueda = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      const targetId = this.editData.id_producto;
      const newActivo = 1 - Number(this.editData.activo || 0);
      this.editData.activo = newActivo;
      axios
        .post(process.env.VUE_APP_API_URL + "producto/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            if (this.productosBusqueda && this.productosBusqueda.data) {
              const idx = this.productosBusqueda.data.findIndex(p => p.id_producto == targetId);
              if (idx !== -1) {
                this.$set(this.productosBusqueda.data[idx], "activo", newActivo);
              }
            }
            Swal.fire({
              title: "Bien!",
              text: "Producto actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {

            if ( this.user.rol == "apruebaproductos") {
      this.getProductosBusquedaTodos();
    }else{
          this.getProductosBusqueda();
    }
        }
      }

        );
    },
    toggleEdit(variable){
      variable=false;
      return variable;
    },
        aprobarProducto: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.aprobacion = 'APROBADO';
      axios
        .post(process.env.VUE_APP_API_URL + "producto/aprobacion", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Producto aprobado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar aprobar producto",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) 
          {

if ( this.user.rol == "apruebaproductos") {
      this.getProductosBusquedaTodos();
    }else{
          this.getProductosBusqueda();
    }

          }


            
        });
    },



  getProductosExcel: function () {
    startAsyncExport("producto", {
      id_integrador: this.id_integrador_sel,
      order_by: {
        field: this.orderByField,
        order: this.orderByDirection,
      },
    }, "Productos");
  },




      rechazarProducto: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.aprobacion = 'RECHAZADO';
      this.editData.atributos = this.atributos;
      this.editData.atributos = {'motivo_rechazo': this.motivoRechazo};
      axios
        .post(process.env.VUE_APP_API_URL + "producto/aprobacion", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Producto rechazado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar rechazar producto",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {

if ( this.user && this.user.rol == "apruebaproductos") {
      this.getProductosBusquedaTodos();
    }else{
          this.getProductosBusqueda();
    }

          }
        });
    },
    editProducto: function () {
      this.errors = null;
      delete this.editData.atributos;
      this.editData.id_integrador = this.id_integrador_sel;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Producto actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {
if ( this.user && this.user.rol == "apruebaproductos") {
      this.getProductosBusquedaTodos(false);
    }else{
          this.getProductosBusqueda(false);
    }


          }
        });
    },
    openAtributosModal: function (item) {
      this.selectedProductoAtributos = item;
      this.showAtributosModal = true;
    },

    closeAtributosModal: function () {
      this.showAtributosModal = false;
      this.selectedProductoAtributos = null;
    },

    showEdit: function (item, operation) {
      this.cargarFiltros();
      this.errors = null;
      this.editData = Object.assign({}, item);

      this.counter = 0;
      if (operation == "add") {
        this.billing_sc_payments = "";
        this.cuadro = [];
        this.editData.tipo = "";
      } else if (operation == "edit") {
        this.getBillingSequence(item.id_producto);

      }
      
 if (operation == "ver") {
      this.getAtributosProducto(item.id_producto);
     

    }
      if (this.editData.categorias != null) {
        this.editData.categorias = this.editData.categorias.split(",");
      } else {
        this.editData.categorias = [];
      }
      this.showModal = true;

      this.operation = operation;
    },
    agregarProducto: function () {
      this.$store.commit("setLoading", true);
      this.editData.id_integrador = this.id_integrador_sel;
      this.errors = null;
      delete this.editData.atributos;

      axios
        .post(process.env.VUE_APP_API_URL + "producto/add", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            const createdProd = (response.data && response.data.data) ? Object.assign({}, response.data.data) : {
              id_producto: response.data && (response.data.id_producto || response.data.id),
              producto: this.editData.producto,
              alias: this.editData.alias,
              activo: this.editData.activo !== undefined ? this.editData.activo : 1,
            };
            if (!createdProd.id_producto && response.data && response.data.id_producto) {
              createdProd.id_producto = response.data.id_producto;
            }
            if (!createdProd.producto) {
              createdProd.producto = this.editData.producto;
            }

            this.showModal = false;
            this.operation = null;
            this.editData = null;

            this.openAtributosModal(createdProd);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) {

if ( this.user.rol == "apruebaproductos") {
      this.getProductosBusquedaTodos(false);
    }else{
          this.getProductosBusqueda(false);
    }

          }
        });
    },


    isMovistar() {
      return this.user && this.user.rol == "movistar";
    },

     isApruebaProducto() {
      return this.user && this.user.rol == "apruebaproductos";
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
    },
    getError(name) {
      if (name) {
        return this.errors && this.errors.errors && this.errors.errors[name]
          ? this.errors.errors[name]
          : null;
      }
      return this.errors && this.errors.error ? this.errors.error : null;
    },
  },
};
</script>
<style scoped></style>